import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    background: var(--dark--background);
    font-family: 'Fira Code', monospace;
    box-sizing: border-box;
  }


  :root{
    --dark--background: #191919;
    --dark--primary--text: #CCCCCC;
    --dark--secondary--text: #A7A7A7;
    --dark--links: #FFFFFF;
    --dark--especial-text: #E5E9F0;
    --dark--green--50: #43D9AD;
    --dark--blue--700: #607B96;
    --dark--blue--500:#4D5BCE;
    --dark--red--700:#E99287;
    --dark--gray--50: #363636;
  }

  ul, li{
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  .menuIcon{
    color: var(--dark--primary--text);
    width: 40px;
    height: 40px;
    margin-right: 1rem;
    margin-top: 1rem;
  }

  .closeMenuDiv{
    width: 100%;
    background-color: var(--dark--background);
    display: flex;
    justify-content: end;
    height: 4rem;
  }

  .menuListItem{
    color: var(--dark--primary--text);
    height: 3rem;
    margin-top: 1rem;
  }

  .socialMediaIcon{
    color: var(--dark--primary--text);
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

`
export default GlobalStyle